import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QRCode from 'qrcode.react';
import moment from 'moment';
import 'moment/locale/ru';

import * as action from '../../actions';
import * as selector from '../../selectors';

const timeFormat = 'HH:mm';

const mapStateToProps = state => {
	return {
		myBookings: selector.getMyBookings(state),
		tables: selector.getTables(state),
	};
};
const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		cancelMyBooking: action.cancelMyBooking.request,
	}, dispatch);
};

@connect(mapStateToProps, mapDispatchToProps)
export default class extends Component {
	static propTypes = {
		myBookings: PropTypes.object,
		tables: PropTypes.object,
		cancelMyBooking: PropTypes.func,
	}

	onCancel = booking_id => {
		if (window.confirm('Вы уверены, что хотите отменить свою бронь?')) { // eslint-disable-line no-alert
			this.props.cancelMyBooking({booking_id});
		}
	}

	render() {
		const {
			myBookings,
			tables,
		} = this.props;
		const {
			list: myBookingsList,
			appleWalletLink,
			isAppleWalletAdded
		} = myBookings.toJS();
		if (!myBookingsList.length || tables.get('loading')) {
			return null;
		}

		return (
			<div className="my">
				{myBookingsList.map(booking => {
					const selectedTable = tables.get('list').toJS().find(table => table.id === booking.table_id);
					const date = moment(booking.from).format('D MMMM');
					const weekDay = moment(booking.from).format('dddd');
					const timeFrom = moment(booking.from).format(timeFormat);
					const timeTill = moment(booking.till).format(timeFormat);

					return (
						<div key={booking.id} className="booking rounded p-3">
							<div className="row">
								<div className="col-sm-12 col-md-9 col-lg-10">
									<div>Вы забронировали</div>
									<div>
										<b>{selectedTable.name}</b> с <b>{timeFrom}</b> до <b>{timeTill}</b> на <b>{date}</b> ({weekDay}).
									</div>
								</div>
								<div className="col-sm-12 col-md-3 col-lg-2">
									<button onClick={() => this.onCancel(booking.id)}
										className="btn btn-block btn-danger custom-bg custom-border"
									>Отменить</button>
								</div>
							</div>
						</div>
					);
				})}
				{appleWalletLink &&
				<div className="booking rounded p-3">
					{!isAppleWalletAdded &&
					<div className="row">
						<div className="col-xs-12 col-sm-8">
							<div><b>Вы пользуетесь iPhone?</b></div>
							<div>
								Добавьте карту гостя себе в Apple Wallet, нажав на кнопку ниже
								или просканировав QR код с вашего телефона.
							</div>
							<div className="apple-wallet-btn">
								<a href={appleWalletLink} target="_blank">
									<img src="https://hookah.name/images/Add_to_Apple_Wallet_rgb_RU.svg" alt="Add to Apple Wallet" />
								</a>
							</div>
						</div>
						<div className="col-xs-12 col-sm-4 qr-code-wrapper">
							<QRCode value={appleWalletLink} className="qr-code" />
						</div>
					</div>}
					{isAppleWalletAdded &&
					<div className="row">
						<div className="col-xs-12 col-sm-8">
							<div>Карта успешно добавлена в Apple Wallet. На всякий случай - вот ссылка на вашу карту:</div>
						</div>
						<div className="col-xs-12 col-sm-4 apple-wallet-btn added">
							<a href={appleWalletLink} target="_blank">
								<img src="https://hookah.name/images/Add_to_Apple_Wallet_rgb_RU.svg" alt="Add to Apple Wallet" />
							</a>
						</div>
					</div>}
				</div>}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/book/BookMy.js